module.exports = __webpack_public_path__ + "img/bg.5720b94e.jpg";